module.exports = __webpack_public_path__ + "img/icon_btm_jr.9bca398e.png";